import type { ReactNode } from 'react';
import { cn } from '@wolfejs/ui/utils/classnames';

export type CartLineItemDetailProps = {
  className?: string;
  children: ReactNode;
};

export const CartLineItemDetail = ({ className, children }: CartLineItemDetailProps) => {
  return <div className={cn('', className)}>{children}</div>;
};
